import { useEffect, useRef } from "react";
import { NotesWithAuthor } from "../api/client";

interface StudentNotesDescriptionProps {
    note: NotesWithAuthor | undefined;
}

export function StudentNotesDescription({note}: StudentNotesDescriptionProps): JSX.Element {
    if (!note) return <></>;

    const containerRef = useRef<HTMLDivElement>(null);

    // Parse rich text from note descripton
    useEffect(() => {
        const container = containerRef.current;

        if(container && note?.content) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(
                String(note.content),
                "text/html"
            );

            // Manipulate the parsed DOM as needed
            const headers = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");
            headers.forEach((h) => {
                h.classList.add("dark:text-white");
            });

            const bold = doc.querySelectorAll("strong");
            bold.forEach((b) => {
                b.classList.add("dark:text-white", "dark:font-bold");
            });

            const links = doc.querySelectorAll("a");
            links.forEach((a) => {
                a.classList.add("dark:text-usfSand", "font-extrabold", "font-extrabold", "text-usfGreen");
                a.setAttribute("target", "_blank");
            });

            const lists = doc.querySelectorAll("li");
            lists.forEach((l) => {
                l.classList.add("dark:text-white", "ml-4", "list-disc");
            })

            container.innerHTML = "";
            container.appendChild(doc.body);
        }
    }, [note]);

    return(<>
        <div key={note.noteId} ref={containerRef} className="prose text-sm sm:text-base dark:text-white p-2 rounded-lg max-w-none"/>         
    </>);
}